
export const REQUEST_FACILITIES_DATA = 'REQUEST_FACILITIES_DATA';
export const RECEIVE_FACILITIES_DATA = 'RECEIVE_FACILITIES_DATA';
export const ERROR_RETRIEVING_FACILITIES_DATA = 'ERROR_RETRIEVING_FACILITIES_DATA';

export const REQUEST_HOLIDAY_HOURS_DATA = 'REQUEST_HOLIDAY_HOURS_DATA';
export const RECEIVE_HOLIDAY_HOURS_DATA = 'RECEIVE_HOLIDAY_HOURS_DATA';

export const receiveFacilitiesData = (payload) => ({
  type: RECEIVE_FACILITIES_DATA,
  payload: payload
});

export const requestHolidayHoursData = (payload) => ({
  type: REQUEST_HOLIDAY_HOURS_DATA,
  payload: payload
});

export const receiveHolidayHoursData = (payload) => ({
  type: RECEIVE_HOLIDAY_HOURS_DATA,
  payload: payload
});

export const errorRetrievingFacilitiesData = error => ({type: ERROR_RETRIEVING_FACILITIES_DATA, payload: error});



// WEBPACK FOOTER //
// ./src/actions/facilitiesActions.js